import { Button, CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

export function useAsignatures() {
  const [asignatures, setAsignatures] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/asignatures')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        setAsignatures(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { asignatures, setAsignatures, isLoading };
}

export default function Asignatures() {
  const { asignatures, setAsignatures, isLoading } = useAsignatures();
  const [name, setName] = React.useState('');
  const [selectedAsignature] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/asignatures-update/${id}`);
  };

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(asignatures[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar las asignaturas seleccionadas?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/asignatures/${
            asignatures[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name,
            }),
          }
        );
        let data = await response.json();
        if (data.success) {
          setAsignatures(asignatures.splice(row?.dataIndex, 1));
        }
      });
    }
  };

  useEffect(() => {
    if (selectedAsignature) {
      setName(selectedAsignature?.name);
    }
  }, [selectedAsignature]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        asignaturas creadas en la plataforma, puedes usar las herramientas,
        filtrar, buscar, imprimir, descargar, para gestionar este módulo, ten
        mucha precaución de eliminar alguna de ellas, si ya cuenta contenido
        asociado, este proceso no se puede recuperar.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de asignaturas'}
          data={asignatures}
          columns={columns}
          options={{
            filter: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
